import React from "react"
import SbEditable from "storyblok-react"
import { TrialButtonStoryblok } from "../../../component-types-sb"
import { useGlobalSettings } from "../../contexts/GlobalSettingsContext"
import LinkButton from "./LinkButton"

interface Props {
  blok: TrialButtonStoryblok
}

const TrialButton: React.FC<Props> = ({ blok }) => {
  const { trial_button } = useGlobalSettings()

  if (trial_button?.length !== 1)
    return <span>Trial button not found, update it in global settings</span>

  return (
    <SbEditable content={blok}>
      <LinkButton button={trial_button[0]} />
    </SbEditable>
  )
}

export default TrialButton
